// extracted by mini-css-extract-plugin
export default {"page":"D1-z","cartModal":"E1-z","checkout":"F1-z","placeholder":"G1-z","account":"H1-z"};